export const NAVIGATION_MODAL_ZINDEX = 1051;
